// extracted by mini-css-extract-plugin
export default {"TipTwo":"TipTwo_TipTwo__qewfR"};